import { render, staticRenderFns } from "./Quest.vue?vue&type=template&id=48fbf291"
import script from "./Quest.vue?vue&type=script&lang=js"
export * from "./Quest.vue?vue&type=script&lang=js"
import style0 from "./Quest.vue?vue&type=style&index=0&id=48fbf291&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports